class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.boundAdjustPosition = this.adjustPosition.bind(this);
    this.mainDetailsToggle.addEventListener('toggle', this.boundAdjustPosition);

    if (window.MutationObserver) {
      this.observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
            if (this.mainDetailsToggle.hasAttribute('open')) {
              this.adjustPosition();
            }
          }
        }
      });
      this.observer.observe(this.mainDetailsToggle, { attributes: true, attributeFilter: ['open'] });
    }
  }

  connectedCallback() {
    this.adjustPosition();
  }

  onToggle() {
    super.onToggle();
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') === '') {
      document.documentElement.style.setProperty(
        '--header-bottom-position-desktop',
        `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
      );
    }

    this.adjustPosition();
  }

  adjustPosition() {
    if (!this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.open) {
      window.removeEventListener('resize', this.boundAdjustPosition);
      return;
    }
    if (!this.content) return;

    window.addEventListener('resize', this.boundAdjustPosition);

    const hadRightClass = this.content.classList.contains('list-menu--right');
    this.content.style.left = '';
    this.content.style.right = '';

    const rect = this.content.getBoundingClientRect();
    const viewportWidth = window.innerWidth || document.documentElement.clientWidth;

    if (rect.right > viewportWidth) {
      this.content.classList.add('list-menu--right');
      const rightAlignedRect = this.content.getBoundingClientRect();
      if (rightAlignedRect.right > viewportWidth) {
        const overflow = rightAlignedRect.right - viewportWidth;
        this.content.style.right = `${overflow + 12}px`;
      }
    } else if (!hadRightClass && this.mainDetailsToggle.getBoundingClientRect().left < viewportWidth / 2) {
      this.content.classList.remove('list-menu--right');
    }
  }
}

customElements.define('header-menu', HeaderMenu);
